import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { WebinarComponent } from './pages/webinar/webinar.component';
import { UnstoppableComponent } from './pages/unstoppable/unstoppable.component';
import { AkshayaTritiyaComponent } from './pages/akshaya-tritiya/akshaya-tritiya.component';
import { WishSipComponent } from './pages/wish-sip/wish-sip.component';
import { WishSipVisComponent } from './pages/wish-sip-vis/wish-sip-vis.component';
import { KhushiyonKiInvestmentComponent } from './pages/khushiyon-ki-investment/khushiyon-ki-investment.component';
import { ColorMyDreamsComponent } from './pages/color-my-dreams/color-my-dreams.component';
import { TaxSavingsComponent } from './pages/tax-savings/tax-savings.component';
import { WishsipthankyouComponent } from './pages/wishsipthankyou/wishsipthankyou.component';
import { LpSipComponent } from './pages/lp-sip/lp-sip.component';
import { SipCampaignComponent } from './pages/sip-campaign/sip-campaign.component';
import { CasautomationComponent } from './pages/casautomation/casautomation.component';
import { PickleballComponent } from './pages/pickleball/pickleball.component';
import { ThankYouComponent } from './pages/thank-you/thank-you.component';
import { NewInvestmentComponent } from './pages/new-investment/new-investment.component';
import { PortfolioReviewComponent } from './pages/portfolio-review/portfolio-review.component';
import { WealthLensReport } from './pages/wealthLens-report/wealthLens-report.component';
import { WealthLensReportViewComponent } from './pages/wealthLens-report-view/wealthLens-report-view.component';
import { WealthLensReportTempComponent } from './pages/wealthLens-report-temp/wealthLens-report-temp.component';
import { NewCampaignComponent } from './pages/new-campaign/new-campaign.component';
import { NewCampaignWAComponent } from './pages/new-camp-wa/new-camp-wa.component';
import { RealestateEldecoComponent } from './realestate-eldeco/realestate-eldeco.component';
import { environment } from 'src/environments/environment';

const routes: Routes = [
  { path: '', redirectTo: 'tax-savings', pathMatch: "full" },
  { path: 'tax-savings', component: TaxSavingsComponent },
  { path: 'new-investment-landing', component: NewInvestmentComponent },
  { path: 'talk-to-bajajcapital', loadChildren: () => import('./pages/new-investment-slide/new-investment-slide.module').then(m => m.NewInvestmentSlideModule) },
  { path: 'talk-to-bajajcapital-advisor', loadChildren: () => import('./pages/talk-to-bcl/talk-to-bcl.module').then(m => m.TalkToBclModule) },
  { path: 'portfolio-review', component: PortfolioReviewComponent },
  {
    // Query params (e.g. ?ref=xyz) are NOT part of the route path, so this
    // single route already matches /wealth-report and /wealth-report?ref=...
    // Header/footer hiding is handled in AppComponent by base-path matching.
    path: 'wealth-report', component: WealthLensReport, data: { hideHeader: true, hideFooter: true }
  },
  {
    path: 'wealth-report-temp', component: WealthLensReportTempComponent, data: { hideHeader: true, hideFooter: true }
  },
  {
    path: 'wealth-report-view', component: WealthLensReportViewComponent, data: { hideHeader: true, hideFooter: true }
  },
  { path: 'nps-webinar', component: WebinarComponent },
  { path: 'sapnokiudaan', component: UnstoppableComponent },
  { path: 'sapnokiudaan-akshayatritiya', component: AkshayaTritiyaComponent },
  { path: 'wish-karo-sip-karo', component: WishSipComponent },
  { path: 'wish-karo-sip-karo-vis', component: WishSipVisComponent },
  { path: 'khushiyonkiinvestment', component: KhushiyonKiInvestmentComponent },
  { path: 'ColorMyDreams', component: ColorMyDreamsComponent },
  { path: 'wish-karo-sip-karo-vis/thankyou', component: WishsipthankyouComponent },
  { path: 'sip', component: LpSipComponent },
  { path: 'sip_campaign', component: SipCampaignComponent },
  { path: 'mf_campaign', component: CasautomationComponent },
  { path: 'event/financial-planning-pickleball', component: PickleballComponent },
  // Reusable Thank You page — source param tells it which page referred
  { path: 'thankyou', component: ThankYouComponent },
  { path: 'talk-to-property-expert', component: NewCampaignComponent },
  { path: 'talk-to-an-expert', component: NewCampaignWAComponent },
  { path: 'realestate-eldeco', component: RealestateEldecoComponent },
  { path: 'realestate-eldeco/thankyou', component: RealestateEldecoComponent },
  // Retirement Readiness (lazy). Behind a flag until launch: off in production, so /retirement keeps going to '**'.
  ...(environment.retirement ? [{ path: 'retirement', loadChildren: () => import('./retirement/retirement.module').then(m => m.RetirementModule) }] : []),
  { path: '**', redirectTo: 'tax-savings' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
